import { useMemo, memo } from "react";
import BetNumber from "../BetNumber";
import styles from "./BetList.module.css";

const BetList: React.FC<{
  betsList: any[];
  betsArray?: string[];
  updateBets?: (newList: any[], newArray: string[]) => void;
  size?: "small" | "default" | "xs" | "xxs";
  align?: "left" | "center";
  defaultType?:
    | "solid"
    | "default"
    | "selected"
    | "user"
    | "user-win"
    | "win"
    | "diamond";
  backgroundColor?: string;
  max?: number;
  min?: number;
  diamond?: number;
  all?: boolean;
}> = ({
  betsList = [],
  betsArray = [],
  updateBets = () => {},
  size = "small",
  align = "center",
  defaultType = "default",
  backgroundColor = "#fff",
  max = 100,
  diamond = 999,
  all = false,
}) => {
  // Use useMemo to avoid unnecessary recalculations
  const bets = useMemo(() => {
    // 如果没有设置diamond ,diamond=999 > betsList,直接渲染
    if (diamond > betsList.length) {
      return betsList;
    }
    if (all && betsArray.length >= diamond) {
      const normal = betsArray.slice(0, diamond - 1);
      const d = betsArray.slice(diamond - 1);
      return betsList.map(item => {
        if (normal.includes(item.number)) {
          return { ...item, isDiamond: false };
        }
        if (d.includes(item.number)) {
          return { ...item, isDiamond: true };
        }
        return item;
      });
    }
    return betsList;
  }, [betsList, betsArray, diamond, all]);
  return (
    <div
      className={styles.list}
      style={{
        justifyContent: align === "left" ? "flex-start" : "center",
        backgroundColor: backgroundColor,
      }}
    >
      {bets.map((item, index) => {
        const handleClick = (number: string) => {
          const canSelect = betsArray.length < max;
          let newArray = Array.isArray(betsArray) ? [...betsArray] : [];
          const currentBet = betsList.find((b: any) => b.number === number);

          if (currentBet) {
            if (currentBet.type === "default" && canSelect) {
              if (!newArray.includes(number)) {
                newArray.push(number);
              }
            } else if (currentBet.type === "selected") {
              newArray = newArray.filter(n => n !== number);
            }
          }
          const newList = betsList.map(bet =>
            bet.number === number
              ? {
                  ...bet,
                  type:
                    bet.type === "default" && canSelect
                      ? "selected"
                      : "default",
                }
              : bet
          );
          updateBets(newList, newArray);
        };

        return (
          <BetNumber
            key={`${item.number || item}-${index}`}
            number={item.number || item}
            type={item.type || defaultType}
            size={size}
            isDiamond={item.isDiamond}
            onClick={handleClick}
          />
        );
      })}
    </div>
  );
};

// Memoize component to prevent unnecessary re-renders
export default memo(BetList);
